import { Link } from 'gatsby';
import React from 'react';

const EventsList = () => {
  return (
    <section className='faq-one'>
      <div className='container'>
        <div className='row no-gutters'>
        <div className='col-lg-6'>
            <div className='faq-one__single'>              
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/events/2024'>
                    2024 Events
                  </Link>
                </h2>                
              </div>
            </div>
          </div>
        <div className='col-lg-6'>
            <div className='faq-one__single'>              
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/events/2023'>
                    2023 Events
                  </Link>
                </h2>                
              </div>
            </div>
          </div>
        <div className='col-lg-6'>
            <div className='faq-one__single'>              
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/events/luthsixty'>
                    LUTH @ 60
                  </Link>
                </h2>                
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>              
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/events/2022'>
                    2022 Events
                  </Link>
                </h2>                
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>             
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/events/2021'>
                    2021 Events
                  </Link>
                </h2>                
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>              
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/events/2020'>
                    2020 Events
                  </Link>
                </h2>                
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>              
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/events/2019'>
                    2019 Events
                  </Link>
                </h2>              
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>              
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/events/2018'>
                    2018 Events
                  </Link>
                </h2>               
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>              
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/events/2017'>
                    2017 Events
                  </Link>
                </h2>                
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='faq-one__single'>              
              <div className='faq-one__content'>
                <h2 className='faq-one__title'>
                  <Link to='/events/2016'>
                    2016 Events
                  </Link>
                </h2>                
              </div>
            </div>
          </div>                  
        </div>
      </div>
    </section>
  );
};

export default EventsList;
